import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

import { RosterYouthMember } from '@appTypes/esb';
import { ProgramId } from '@shared/constants';

export function getLatestRankApproved(youth: RosterYouthMember) {
  const { highestRanksApproved = [], highestRanksAwarded = [] } = youth;

  if (!highestRanksApproved.length && !highestRanksAwarded.length) {
    return null;
  }

  const ranksToSort = [...highestRanksApproved, ...highestRanksAwarded];

  // Deduplicate by id + programId
  const uniqueRanks = uniqBy(
    ranksToSort,
    rank => `${rank.id}-${rank.programId}`,
  );

  const sorted = orderBy(
    uniqueRanks,
    [
      // Cub Scout (programId = 1) has lower priority (true sorts after false)
      rank => rank.programId === ProgramId.CUB_SCOUT,
      // Higher level first
      'level',
    ],
    ['asc', 'desc'],
  );

  return sorted[0] || null;
}
